import { ComponentStoreFactory } from '../../../../../shared/store/common/component-store.factory';
import { WorkplaceGridObject } from '@it2go/types';
import { Injectable, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { WorkplaceService } from '../../../../../../services/workplace.service';
import { FilterBuilder } from '../../../../helper/filter.builder';

interface State {
    workplaces: WorkplaceGridObject | null,
}

const defaultState: State = {
    workplaces: null,
};

@Injectable()
export class WorkplaceTableStore extends ComponentStoreFactory<State> {

    public serviceId: number | null = null;

    constructor() {
        super(defaultState, inject(Store), inject(WorkplaceService));
        this.subs.push(
            this.routeParam.serviceId.subscribe(async (it) => {
                this.serviceId = Number(it) || null;
                await this.refreshData();
            }),
        );
    }

    public async refreshData(): Promise<void> {
        if (this.serviceId) {
            this.api.getWorkplaces(FilterBuilder.filter({ serviceId: this.serviceId }));
        }
    }

}
